export enum CtaType {
  EPX = 'epx',
  EMS = 'ems',
}
